import { Entity } from "../api";

export const STICKY_NOTE_QUALIFIED_NAME = "native.sticky-note";

/**
 * Static sticky note entity definition
 * No need to fetch from server - it's a native entity with fixed properties
 */
const STICKY_NOTE_ENTITY: Entity = {
  className: "Sticky Note",
  colorSchema: "yellow",
  createdAt: new Date().toISOString(),
  defaultValue: "New Sticky Note",
  description: "A sticky note for quick annotations and reminders",
  entityClassId: "",
  icon: "file",
  id: "00000000-0000-0000-0000-000000000002",
  isNative: true,
  name: "Sticky Note",
  qualifiedName: STICKY_NOTE_QUALIFIED_NAME,
  updatedAt: new Date().toISOString(),
};

/**
 * Check if an entity is a sticky note
 */
export const isStickyNoteEntity = (entity: Entity): boolean => {
  return entity.qualifiedName === STICKY_NOTE_QUALIFIED_NAME;
};

/**
 * Get the sticky note entity (synchronous)
 * Returns static entity definition - no server call needed
 */
export const getStickyNoteEntity = (): Entity => {
  return STICKY_NOTE_ENTITY;
};

/**
 * Check if a node is a sticky note based on its entity ID
 */
export const isStickyNoteNode = (node: cytoscape.NodeSingular): boolean => {
  return node.data("entityQualifiedName") === STICKY_NOTE_QUALIFIED_NAME;
};
